import React from "react";

var Bin = function Bin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2 0c-.665 0-1.243.332-1.63.815A2.707 2.707 0 004 2.5V3H1a1 1 0 000 2h1v8.9c0 .56.225 1.095.622 1.489.397.392.932.611 1.49.611h7.777c.557 0 1.092-.219 1.49-.611.396-.394.621-.929.621-1.489V5h1a1 1 0 100-2h-3v-.5c0-.6-.189-1.208-.57-1.685C11.042.332 10.464 0 9.8 0H6.2zM10 3v-.5a.715.715 0 00-.132-.436.23.23 0 00-.069-.062L9.795 2h-3.59l-.004.002a.23.23 0 00-.069.062A.715.715 0 006 2.5V3h4zM5 5H4v8.9c0 .023.01.048.029.067.02.02.05.033.082.033h7.778a.117.117 0 00.082-.033A.094.094 0 0012 13.9V5H5zm1.5 1.5a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1zm4 1a1 1 0 10-2 0v4a1 1 0 102 0v-4z",
    fill: "currentColor"
  }));
};

Bin.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { Bin };